
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Footer, Navbar } from './components';
import { About, AuthPage, Companies, CompanyProfile, FindJobs, JobDetail, UploadJob, UserProfile } from './pages';
import { store } from './redux/store';
import CompanyForm from './pages/updateCompany';
import Pagenotfound from './components/pagenotfound'; // Corrected import
import Updatejob from './pages/updatejob';

function App() {
  return (
    <Provider store={store}>
      <main className='bg-[#f7fdfd]'>
        <BrowserRouter>
          <Navbar />
          <Routes>
            {/* Replace the root route with the desired component */}
            <Route path='/' element={<Navigate to='/find-jobs' />} />
            <Route path='/dashboard' element={<AuthPage />} />
            <Route path='/update-company' element={<CompanyForm/>}/>
            <Route path="/" element={<UserProfile/>}/>
            <Route path='/find-jobs' element={<FindJobs />} />
            <Route path='/companies' element={<Companies />} />
            <Route path='/about-us' element={<About />} />

            {/* Protected Routes */}
            <Route path='/user-profile' element={<UserProfile />} />
            <Route path='/user-profile/:id' element={<UserProfile />} />
            <Route path='/company-profile' element={<CompanyProfile />} />
            <Route path='/company-profile/:id' element={<CompanyProfile />} />
            <Route path='/upload-job' element={<UploadJob />} />
            <Route path='/job-detail/:id' element={<JobDetail />} />
            
            
            {/* Public Route */}
            <Route path='/user-auth' element={<AuthPage />} />
            <Route path='/update-job/:id' element={<Updatejob />} />
            <Route path='*' element={<Pagenotfound />} /> {/* Corrected component name */}
          </Routes>
          <Footer />
        </BrowserRouter>
      </main>
    </Provider>
  );
}

export default App;
